(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(diagram) {
    var center = diagram.querySelector('.bc-ingredients__center');
    var items = Array.prototype.slice.call(diagram.querySelectorAll('.bc-ingredients__item'));

    if (center) center.classList.add('is-visible');

    items.forEach(function (item, index) {
      setTimeout(function () {
        item.classList.add('is-visible');
      }, index * 180);
    });
  }

  function revealInstantly(diagram) {
    var center = diagram.querySelector('.bc-ingredients__center');
    if (center) center.classList.add('is-visible');
    diagram.querySelectorAll('.bc-ingredients__item').forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  function init(root) {
    root.querySelectorAll('[data-ingredients-diagram]').forEach(function (diagram) {
      if (diagram.dataset.ingredientsInit) return;
      diagram.dataset.ingredientsInit = 'true';

      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealInstantly(diagram);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            reveal(diagram);
            observer.disconnect();
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(diagram);
    });
  }

  init(document);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
